import { Component } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { NodeService } from '../../Services/api-nodeservice';
import { Api } from '../../Model/api-model';
import { Router } from '@angular/router';
import {RestApiService} from '../../Services/rest-api-service'
import { ApiListDevPortal, ApiDevPortal } from 'src/app/Model/apilist-model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-products-subscriptionstatus',
  templateUrl: './products-subscriptions-status.component.html'
})
export class ProductsSubscriptionStatusComponent{
  selectedApi:ApiDevPortal ;

  divRender: boolean;
  apis:Api[];
  cols: any[];
  publicListApi:ApiListDevPortal;
  publicApi:ApiDevPortal[];
  loadAppRequest:boolean=false;
  showTopDiv=false;

    //stat='default';
    role;
    fileName;
    roleDesc='Third party developer';
    devStatus_qu;
    payerStatus_qu;
    displayPendingMSG=false;

    regionLabel;
   




  }

